export default __webpack_public_path__ + "static/Do-Keep-content-simple-and-focused-0ed8abaf0bac44e415f5e94d2ad501ce.png";